import {HolidaysList} from "./HolidaysList";
import {HolidaysEdit} from "./HolidaysEdit";
import {HolidaysCreate} from "./HolidaysCreate";

export default {
    list: HolidaysList,
    create: HolidaysCreate,
    edit: HolidaysEdit
};
